"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Accordion2 = _interopRequireDefault(require("@material-ui/core/Accordion"));

var _AccordionDetails2 = _interopRequireDefault(require("@material-ui/core/AccordionDetails"));

var _AccordionSummary2 = _interopRequireDefault(require("@material-ui/core/AccordionSummary"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

var _utils = require("@material-ui/core/utils");

var _AccordionExpandIcon = _interopRequireDefault(require("./AccordionExpandIcon"));

var _Accordion3 = _interopRequireWildcard(require("./Accordion.styles"));

var _AccordionTransition = _interopRequireDefault(require("./AccordionTransition"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Accordion = /*#__PURE__*/(0, _react.forwardRef)(function Accordion(props, ref) {
  var className = props.className,
      data = props.data,
      defaultExpanded = props.defaultExpanded,
      disabled = props.disabled,
      expandedProp = props.expanded,
      multiple = props.multiple,
      _onChange = props.onChange;

  var _useControlled = (0, _utils.useControlled)({
    controlled: expandedProp,
    default: defaultExpanded,
    name: 'Accordion'
  }),
      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
      expanded = _useControlled2[0],
      setExpanded = _useControlled2[1];

  var accordionClasses = (0, _Accordion3.default)();

  var _useExpansionPanelSum = (0, _Accordion3.useExpansionPanelSummaryStyles)(),
      summaryIconClass = _useExpansionPanelSum.icon,
      summaryClasses = (0, _objectWithoutProperties2.default)(_useExpansionPanelSum, ["icon"]);

  var expansionPanelClasses = (0, _Accordion3.useExpansionPanelStyles)();
  var expansionPanelDetailsClasses = (0, _Accordion3.useExpansionPanelDetailsStyles)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('pds-accordion', accordionClasses.root, className),
    ref: ref
  }, data.map(function (item) {
    var itemClassName = item.className,
        details = item.details,
        itemDisabled = item.disabled,
        header = item.header,
        icon = item.icon,
        id = item.id,
        otherProps = (0, _objectWithoutProperties2.default)(item, ["className", "details", "disabled", "header", "icon", "id"]);
    return /*#__PURE__*/_react.default.createElement(_Accordion2.default, Object.assign({}, otherProps, {
      key: id,
      className: (0, _classnames.default)('pds-accordion__section', itemClassName),
      classes: expansionPanelClasses,
      defaultExpanded: defaultExpanded && defaultExpanded[id],
      disabled: disabled || itemDisabled,
      elevation: 0,
      expanded: !!(expanded && expanded[id]),
      onChange: function onChange(e, isExpanded) {
        var newState = _objectSpread(_objectSpread({}, multiple ? expanded : {}), {}, (0, _defineProperty2.default)({}, id, isExpanded));

        setExpanded(newState);

        if (_onChange) {
          _onChange(id, isExpanded);
        }
      },
      TransitionComponent: _AccordionTransition.default,
      square: true
    }), /*#__PURE__*/_react.default.createElement(_AccordionSummary2.default, {
      className: "pds-accordion__section-header",
      classes: summaryClasses,
      expandIcon: /*#__PURE__*/_react.default.createElement(_AccordionExpandIcon.default, {
        className: "pds-accordion__expand-icon"
      }),
      id: "".concat(id, "-header"),
      "aria-controls": "".concat(id, "-detail")
    }, icon && /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)('pds-accordion__section-header-icon', summaryIconClass)
    }, icon), header), /*#__PURE__*/_react.default.createElement(_AccordionDetails2.default, {
      className: "pds-accordion__section-body",
      classes: expansionPanelDetailsClasses
    }, details));
  }));
});
Accordion.propTypes = {
  /**
   * The CSS class that will be added to the root node of the component.
   */
  className: _propTypes.string,

  /**
   * Array of objects that contains information to be used in each section of the `Accordion`.
   */
  data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    className: _propTypes.string,
    details: _propTypes.node,
    disabled: _propTypes.bool,
    header: _propTypes.node.isRequired,
    icon: _propTypes.node,
    id: _propTypes.string.isRequired
  })).isRequired,

  /**
   * If the component is in uncontrolled mode you can use this prop to
   * decide which sections of the Accordion are expanded when the component
   * is mounted.
   *
   * The `key` is the ID of the section and the value is a boolean.
   */
  defaultExpanded: (0, _propTypes.objectOf)(_propTypes.bool),

  /**
   * Whether or not the ExpansionPanels in the Accordion can be interacted
   * with. If set to true, this will take precedence over the individual
   * `disabled` props for the Expansion Panels.
   */
  disabled: _propTypes.bool,

  /**
   * If the component is in controlled mode you can use this prop to decide
   * which sections of the Accordion should be expanded.
   *
   * If you pass the prop make sure you also set the `onChange` prop otherwise
   * the state won't change when the user tries to toggle any of the sections.
   */
  expanded: (0, _propTypes.objectOf)(_propTypes.bool),

  /**
   * If `true` the component could have more than one section expanded.
   *
   * **Only used if the component is in uncontrolled mode.** When it is
   * controlled you are responsible of handling that behavior.
   */
  multiple: _propTypes.bool,

  /**
   * Callback called when one of the sections of the accordion is toggled.
   *
   * @param {String} id the `id` field from the item that is getting toggled.
   * @param {boolean} expanded `true` if the section is getting expanded and `false` if it is being closed.
   */
  onChange: _propTypes.func
};
var _default = Accordion;
exports.default = _default;
